import { render, staticRenderFns } from "./certificateList.vue?vue&type=template&id=6416f640&scoped=true"
import script from "./certificateList.vue?vue&type=script&lang=js"
export * from "./certificateList.vue?vue&type=script&lang=js"
import style0 from "./certificateList.vue?vue&type=style&index=0&id=6416f640&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6416f640",
  null
  
)

export default component.exports